module.exports = "/assets/data/f33bf63b3eec7ec5f0f6bff0f581a8f1-CM22.data.json";